<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post3hormuz-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post3hormuz-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.64707142537666;"
    data-aspect-ratio="0.647"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post3hormuz-xs-img"
      class="g-post3hormuz-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post3hormuz-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:6.6827%;margin-top:-6.1px;left:47.3161%;width:55px;"
    >
      <p class="g-pstyle0">Iran</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:32.1734%;margin-top:-7.1px;left:62.2528%;width:63px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:38.9728%;margin-top:-13.8px;left:12.1671%;width:106px;"
    >
      <p class="g-pstyle2">Iranian naval</p>
      <p class="g-pstyle2">bases</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:42.7862%;margin-top:-7.2px;left:66.4357%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:53.5626%;margin-top:-7.2px;left:79.6439%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle4">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:57.084%;margin-top:-7.1px;left:79.711%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle5">58 km</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:61.1265%;margin-top:-15.7px;left:31.9335%;margin-left:-70px;width:140px;"
    >
      <p class="g-pstyle6">Exclusive Economic</p>
      <p class="g-pstyle6">Zone of Iran</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:69.2329%;margin-top:-7.1px;right:60.4112%;width:126px;"
    >
      <p class="g-pstyle7">Overlapping claim</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:77.8605%;margin-top:-7.1px;left:32.3341%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle8">uae</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:92.1746%;margin-top:-7.1px;left:52.7088%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle8">Oman</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post3hormuz-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.01534304617474;"
    data-aspect-ratio="1.015"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post3hormuz-sm-img"
      class="g-post3hormuz-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post3hormuz-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:3.5997%;margin-top:-6.1px;left:47.8969%;width:55px;"
    >
      <p class="g-pstyle0">Iran</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:28.4856%;margin-top:-7.1px;left:54.5945%;width:63px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:35.1901%;margin-top:-13.8px;left:22.1861%;width:106px;"
    >
      <p class="g-pstyle2">Iranian naval</p>
      <p class="g-pstyle2">bases</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:34.06%;margin-top:-7.1px;left:6.7194%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle3">iraq</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:39.8583%;margin-top:-7.2px;left:61.0437%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle4">Iran</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:42.2226%;margin-top:-7.1px;left:5.8924%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle3">Kuwait</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:47.9961%;margin-top:-8.1px;left:12.1419%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle5">The Gulf</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:49.3979%;margin-top:-8.1px;right:60.5158%;width:74px;"
    >
      <p class="g-pstyle6">The Gulf</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:50.0034%;margin-top:-7.2px;left:65.8475%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle7">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:53.5788%;margin-top:-7.1px;left:65.891%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle8">58 km</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:66.113%;margin-top:-7.1px;right:60.0703%;width:126px;"
    >
      <p class="g-pstyle9">Overlapping claim</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:73.8093%;margin-top:-15.7px;left:83.681%;margin-left:-70px;width:140px;"
    >
      <p class="g-pstyle10">Exclusive Economic</p>
      <p class="g-pstyle10">Zone of Iran</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:77.0628%;margin-top:-7.1px;left:31.7737%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle3">uae</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:89.4061%;margin-top:-7.1px;left:48.419%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle3">Oman</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:91.1253%;margin-top:-13.7px;left:10.1607%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle3">Saudi</p>
      <p class="g-pstyle3">Arabia</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post3hormuz-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.41249942929952;"
    data-aspect-ratio="1.412"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post3hormuz-md-img"
      class="g-post3hormuz-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post3hormuz-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:6.0098%;margin-top:-6.1px;left:87.3005%;width:55px;"
    >
      <p class="g-pstyle0">Iran</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:16.0685%;margin-top:-7.1px;left:52.6446%;width:63px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:24.6291%;margin-top:-7.1px;left:10.9641%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle2">iraq</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:34.099%;margin-top:-7.3px;left:62.7946%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:33.6177%;margin-top:-7.1px;left:7.3497%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle2">Kuwait</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:40.2611%;margin-top:-8.1px;left:15.3104%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle4">The Gulf</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:44.131%;margin-top:-7.2px;left:63.3796%;margin-left:-71.5px;width:143px;"
    >
      <p class="g-pstyle5">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:46.0306%;margin-top:-7.1px;left:25.4002%;margin-left:-22px;width:44px;"
    >
      <p class="g-pstyle6">Iran</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:48.1796%;margin-top:-7.1px;left:63.4234%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle7">58 km</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:52.451%;margin-top:-7.1px;left:18.6007%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle6">Qatar</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:54.3772%;margin-top:-7.1px;right:58.8888%;width:126px;"
    >
      <p class="g-pstyle8">Overlapping claim</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:58.2294%;margin-top:-7.1px;right:89.7786%;width:65px;"
    >
      <p class="g-pstyle9">Qatar</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:59.0855%;margin-top:-7.1px;left:59.8364%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle6">Oman</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:59.9504%;margin-top:-7.1px;left:75.2077%;width:146px;"
    >
      <p class="g-pstyle10">Iranian naval bases</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:63.7938%;margin-top:-7.1px;left:30.5865%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle6">UAE</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:64.4448%;margin-top:-7.1px;left:85.6766%;width:103px;"
    >
      <p class="g-pstyle10">Coast of Iran</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:66.148%;margin-top:-7.1px;left:58.333%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle6">UAE</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:71.4984%;margin-top:-7.1px;left:39.9253%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle2">uae</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:76.9896%;margin-top:-15.7px;left:87.4408%;margin-left:-70px;width:140px;"
    >
      <p class="g-pstyle11">Exclusive Economic</p>
      <p class="g-pstyle11">Zone of Iran</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:80.273%;margin-top:-7.1px;left:69.2372%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle6">Oman</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:84.7673%;margin-top:-7.1px;left:44.2526%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:87.4714%;margin-top:-13.7px;left:6.6238%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle2">Saudi</p>
      <p class="g-pstyle2">Arabia</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post3hormuz-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.65244691916858;"
    data-aspect-ratio="1.652"
    data-min-width="930"
  >
    <div
      id="g-post3hormuz-lg-img"
      class="g-post3hormuz-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post3hormuz-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:11.2084%;margin-top:-7.1px;left:85.5801%;width:55px;"
    >
      <p class="g-pstyle0">Iran</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:16.3612%;margin-top:-8.1px;left:68.0781%;margin-left:-62px;width:124px;"
    >
      <p class="g-pstyle1">Turkmenistan</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:19.3965%;margin-top:-8.2px;left:47.46%;width:69px;"
    >
      <p class="g-pstyle2">Tehran</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:27.3775%;margin-top:-8.1px;left:14.4465%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle1">iraq</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:36.1355%;margin-top:-8.4px;left:55.4971%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:35.5509%;margin-top:-8.1px;left:11.5831%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle1">Kuwait</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:41.7919%;margin-top:-8.2px;left:17.3184%;margin-left:-40.5px;width:81px;"
    >
      <p class="g-pstyle4">The Gulf</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:45.5306%;margin-top:-8.2px;left:55.9569%;margin-left:-75px;width:150px;"
    >
      <p class="g-pstyle5">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:46.9373%;margin-top:-8.2px;left:25.9275%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle6">Iran</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:49.0695%;margin-top:-8.2px;left:55.957%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle7">58 km</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:53.1488%;margin-top:-8.1px;left:20.4766%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle8">Qatar</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:54.748%;margin-top:-8.1px;right:61.8963%;width:133px;"
    >
      <p class="g-pstyle9">Overlapping claim</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:58.4719%;margin-top:-8.1px;right:86.141%;width:65px;"
    >
      <p class="g-pstyle10">Qatar</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:59.19%;margin-top:-8.1px;left:53.1839%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle8">Oman</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:60.0858%;margin-top:-8.2px;left:65.3304%;width:154px;"
    >
      <p class="g-pstyle2">Iranian naval bases</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:63.6321%;margin-top:-8.1px;left:30.0014%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle8">UAE</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:64.1725%;margin-top:-8.2px;left:73.6218%;width:108px;"
    >
      <p class="g-pstyle2">Coast of Iran</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:65.7643%;margin-top:-8.1px;left:51.9771%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle8">UAE</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:70.732%;margin-top:-8.1px;left:37.3873%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle1">uae</p>
    </div>
    <div
      id="g-ai3-20"
      class="g-iranshadow g-aiAbs g-aiPointText"
      style="top:77.2321%;margin-top:-17.7px;left:77.2765%;margin-left:-74px;width:148px;"
    >
      <p class="g-pstyle11">Exclusive Economic</p>
      <p class="g-pstyle11">Zone of Iran</p>
    </div>
    <div
      id="g-ai3-21"
      class="g-darkshadow g-aiAbs g-aiPointText"
      style="top:78.7351%;margin-top:-8.1px;left:60.6295%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle8">Oman</p>
    </div>
    <div
      id="g-ai3-22"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:84.1301%;margin-top:-15.5px;left:9.7349%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle1">Saudi</p>
      <p class="g-pstyle1">Arabia</p>
    </div>
    <div
      id="g-ai3-23"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:82.9921%;margin-top:-8.1px;left:40.8146%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle1">Oman</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-03 09:49 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-03-03 09:49 -->
<!-- ai file: post3hormuz.ai -->
<style lang="scss">
  #g-post3hormuz-box {
    container-type: inline-size;
    container-name: g-post3hormuz-box;
  }
  #g-post3hormuz-box,
  #g-post3hormuz-box .g-artboard {
    margin: 0 auto;
  }
  #g-post3hormuz-box p {
    margin: 0;
  }
  #g-post3hormuz-box .g-aiAbs {
    position: absolute;
  }
  #g-post3hormuz-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post3hormuz-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post3hormuz-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post3hormuz-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post3hormuz-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post3hormuz-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post3hormuz-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post3hormuz-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post3hormuz-lg {
        display: block !important;
      }
    }
  }
  #g-post3hormuz-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post3hormuz-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    font-style: normal;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    position: static;
  }
  #g-post3hormuz-xs .g-pstyle0 {
    font-weight: 900;
    line-height: 11px;
    height: 11px;
    font-size: 14px;
    text-transform: uppercase;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-xs .g-pstyle1 {
    font-weight: 500;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-xs .g-pstyle2 {
    font-weight: 500;
    line-height: 13px;
    height: 13px;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-xs .g-pstyle3 {
    font-weight: 900;
    line-height: 13px;
    height: 13px;
    letter-spacing: 0.32em;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-xs .g-pstyle4 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    font-size: 16px;
    text-align: center;
    color: rgb(34, 68, 86);
  }
  #g-post3hormuz-xs .g-pstyle5 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    text-align: center;
    color: rgb(34, 68, 86);
  }
  #g-post3hormuz-xs .g-pstyle6 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    text-align: center;
  }
  #g-post3hormuz-xs .g-pstyle7 {
    font-weight: 400;
    font-style: italic;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: right;
  }
  #g-post3hormuz-xs .g-pstyle8 {
    font-weight: 500;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-post3hormuz-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post3hormuz-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    font-style: normal;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    position: static;
  }
  #g-post3hormuz-sm .g-pstyle0 {
    font-weight: 900;
    line-height: 11px;
    height: 11px;
    font-size: 14px;
    text-transform: uppercase;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-sm .g-pstyle1 {
    font-weight: 500;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-sm .g-pstyle2 {
    font-weight: 500;
    line-height: 13px;
    height: 13px;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-sm .g-pstyle3 {
    font-weight: 500;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-post3hormuz-sm .g-pstyle4 {
    font-weight: 900;
    line-height: 13px;
    height: 13px;
    letter-spacing: 0.32em;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-sm .g-pstyle5 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(159, 169, 177);
  }
  #g-post3hormuz-sm .g-pstyle6 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    text-align: right;
    color: rgb(115, 130, 141);
  }
  #g-post3hormuz-sm .g-pstyle7 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    font-size: 16px;
    text-align: center;
    color: rgb(34, 68, 86);
  }
  #g-post3hormuz-sm .g-pstyle8 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    text-align: center;
    color: rgb(34, 68, 86);
  }
  #g-post3hormuz-sm .g-pstyle9 {
    font-weight: 400;
    font-style: italic;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: right;
  }
  #g-post3hormuz-sm .g-pstyle10 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    text-align: center;
  }
  #g-post3hormuz-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post3hormuz-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 13px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(171, 64, 75);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post3hormuz-md .g-pstyle0 {
    font-weight: 900;
    line-height: 11px;
    height: 11px;
    font-size: 14px;
    text-transform: uppercase;
  }
  #g-post3hormuz-md .g-pstyle1 {
    font-weight: 500;
    height: 13px;
    font-size: 14px;
  }
  #g-post3hormuz-md .g-pstyle2 {
    font-weight: 500;
    height: 13px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-post3hormuz-md .g-pstyle3 {
    font-weight: 900;
    height: 13px;
    letter-spacing: 0.56em;
    font-size: 20px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post3hormuz-md .g-pstyle4 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    text-align: center;
    color: rgb(159, 169, 177);
  }
  #g-post3hormuz-md .g-pstyle5 {
    font-weight: 700;
    height: 13px;
    font-size: 17px;
    text-align: center;
    color: rgb(34, 68, 86);
  }
  #g-post3hormuz-md .g-pstyle6 {
    font-weight: 400;
    font-style: italic;
    height: 13px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-post3hormuz-md .g-pstyle7 {
    font-weight: 700;
    height: 13px;
    text-align: center;
    color: rgb(34, 68, 86);
  }
  #g-post3hormuz-md .g-pstyle8 {
    font-weight: 400;
    font-style: italic;
    height: 13px;
    font-size: 14px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-post3hormuz-md .g-pstyle9 {
    font-weight: 500;
    height: 13px;
    font-size: 14px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-post3hormuz-md .g-pstyle10 {
    font-weight: 500;
    height: 13px;
  }
  #g-post3hormuz-md .g-pstyle11 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-post3hormuz-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post3hormuz-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post3hormuz-lg .g-pstyle0 {
    font-weight: 900;
    line-height: 13px;
    height: 13px;
    text-transform: uppercase;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-lg .g-pstyle1 {
    font-weight: 500;
    height: 15px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post3hormuz-lg .g-pstyle2 {
    font-weight: 500;
    height: 15px;
    font-size: 16px;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-lg .g-pstyle3 {
    font-weight: 900;
    height: 15px;
    letter-spacing: 0.56em;
    font-size: 21px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(171, 64, 75);
  }
  #g-post3hormuz-lg .g-pstyle4 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    font-size: 17px;
    text-align: center;
    color: rgb(159, 169, 177);
  }
  #g-post3hormuz-lg .g-pstyle5 {
    font-weight: 700;
    height: 15px;
    font-size: 18px;
    text-align: center;
    color: rgb(34, 68, 86);
  }
  #g-post3hormuz-lg .g-pstyle6 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    font-size: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-post3hormuz-lg .g-pstyle7 {
    font-weight: 700;
    height: 15px;
    font-size: 16px;
    text-align: center;
    color: rgb(34, 68, 86);
  }
  #g-post3hormuz-lg .g-pstyle8 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    font-size: 15px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-post3hormuz-lg .g-pstyle9 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    font-size: 15px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-post3hormuz-lg .g-pstyle10 {
    font-weight: 500;
    height: 15px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-post3hormuz-lg .g-pstyle11 {
    font-weight: 400;
    font-style: italic;
    line-height: 17px;
    height: 17px;
    font-size: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }

  /* Custom CSS */
  @mixin shadow-emmental($clr) {
    text-shadow:
      -1px 0 rgba($clr, 1),
      0 1px rgba($clr, 1),
      1px 0 rgba($clr, 1),
      0 -1px rgba($clr, 1);
  }
  .g-darkshadow {
    @include shadow-emmental(#103448);
  }

  .g-shadowtext {
    @include shadow-emmental(#ffffff);
  }
</style>
